const primaryDisabled = {
    '&:disabled': {
        cursor: 'default',
        backgroundColor: 'neutralBgStrongDisabled',
        borderColor: 'neutralBorderStrongDisabled',
        color: 'baseTextWeak',
    },
};
const secondaryDisabled = {
    '&:disabled': {
        cursor: 'default',
        backgroundColor: 'neutralBg',
        borderColor: 'neutralBorderStrongDisabled',
        color: 'neutralTextStrongDisabled',
    },
};
const tertiaryDisabled = {
    '&:disabled': {
        cursor: 'default',
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        color: 'neutralTextStrongDisabled',
    },
};
export const buttons = {
    primary: Object.assign({ color: 'baseTextWeak', backgroundColor: 'baseBg', borderColor: 'baseBorder', '&:hover': {
            backgroundColor: 'baseBgActive',
            borderColor: 'baseBorderActive',
        } }, primaryDisabled),
    secondary: Object.assign({ color: 'baseText', backgroundColor: 'neutralBg', borderColor: 'baseBorder', '&:hover': {
            color: 'baseTextActive',
            borderColor: 'baseBorderActive',
        } }, secondaryDisabled),
    tertiary: Object.assign({ color: 'baseText', backgroundColor: 'transparent', borderColor: 'transparent', '&:hover': {
            color: 'baseTextActive',
            backgroundColor: 'transparent',
        } }, tertiaryDisabled),
    destructive: Object.assign({ color: 'baseTextWeak', backgroundColor: 'dangerBgMedium', borderColor: 'dangerBorder', '&:hover': {
            backgroundColor: 'dangerBgMediumActive',
            borderColor: 'dangerBorderActive',
        } }, primaryDisabled),
    destructiveSecondary: Object.assign({ color: 'dangerTextWeak', backgroundColor: 'neutralBg', borderColor: 'dangerBorder', '&:hover': {
            color: 'dangerTextActive',
            borderColor: 'dangerBorderActive',
        } }, secondaryDisabled),
    destructiveTertiary: Object.assign({ color: 'dangerTextWeak', backgroundColor: 'transparent', borderColor: 'transparent', '&:hover': {
            color: 'dangerTextActive',
        } }, tertiaryDisabled),
    onChocoBlue: Object.assign({ color: 'baseTextWeak', backgroundColor: 'baseBgMedium', borderColor: 'baseBorderMedium', '&:hover': {
            backgroundColor: 'baseBgMediumActive',
            borderColor: 'baseBorderMediumActive',
        } }, primaryDisabled),
    onChocoBlueSecondary: Object.assign({ color: 'baseTextMedium', backgroundColor: 'neutralBg', borderColor: 'baseBorderMedium', '&:hover': {
            color: 'baseTextStrong',
            borderColor: 'baseBorderMediumActive',
        } }, secondaryDisabled),
    onChocoBlueTertiary: Object.assign({ color: 'baseTextMedium', backgroundColor: 'transparent', borderColor: 'transparent', '&:hover': {
            color: 'baseBorderMediumActive',
        } }, tertiaryDisabled),
};
export const buttonSizesStyles = {
    small: {
        px: 'm',
        py: 'xxs',
        minWidth: '80px',
    },
    medium: {
        px: 'xl',
        py: 'xs',
        minWidth: '120px',
    },
    large: {
        px: 'xxl',
        py: 's',
        minWidth: '120px',
    },
};
//# sourceMappingURL=data:application/json;base64,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